import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const ResourceState = {
  resources: {
    loading: false,
    resources: [],
  },
}

export const ResourceActions = {
  searchResources: async function ({ commit }, params) {
    commit('setResourcesLoading', true)

    return axiosRequest.post('/permissions/resources/search', params).
      then(({ data }) => {
        commit('setResources', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setResourcesLoading', false))
  },

  selectResources: async function ({ commit }, params) {
    commit('setResourcesLoading', true)

    return axiosRequest.post('/permissions/resources/search/select', params).
      then(({ data }) => data).
      catch(handleError).
      finally(_ => commit('setResourcesLoading', false))
  },

  getAccessRequests: async function ({ commit }) {
    commit('setResourcesLoading', true)

    return axiosRequest.get('permissions/resources/access_request').
      then(({ data }) => data).
      catch(handleError).
      finally(_ => commit('setResourcesLoading', false))
  },

  grantResourceAccess: async function ({ commit }, { requestIds }) {
    commit('setResourcesLoading', true)

    return axiosRequest.post('permissions/resources/access_request/grant', { ids: requestIds }).
      then(({ data }) => data).
      catch(handleError).
      finally(_ => commit('setResourcesLoading', false))
  },

  grantExplainResourceAccess: async function ({ commit }, { requestIds }) {
    commit('setResourcesLoading', true)

    return axiosRequest.post('permissions/resources/access_request/grant_explain', { ids: requestIds }).
      then(({ data }) => data).
      catch(handleError).
      finally(_ => commit('setResourcesLoading', false))
  },

  revokeResourceAccess: async function ({ commit }, { requestIds }) {
    commit('setResourcesLoading', true)

    return axiosRequest.post('permissions/resources/access_request/revoke', { ids: requestIds }).
      then(({ data }) => data).
      catch(handleError).
      finally(_ => commit('setResourcesLoading', false))
  },

  getResourceAccessCount: async function (_) {
    return axiosRequest.get('permissions/resources/access_request/count').
      then(({ data }) => data).
      catch(handleError)
  },
}

export const ResourceGetters = {
  resources: state => state.resources.resources || [],
  resourcesLoading: state => state.resources.loading || false,
}
export const ResourceMutations = {
  setResources: (state, resources) => (state.resources.resources = resources),
  setResourcesLoading: (state, loading) => (state.resources.loading = loading),
}
